import Loading from 'vue-loading-overlay'

export default {
  Loading
}



// WEBPACK FOOTER //
// ./src/app/dweller/unit/resources/components.js